const pageLoader: HTMLElement | null = document.querySelector('.page-loader');

export function initPageLoader() {
  if (pageLoader) {
    pageLoader.classList.add('done');
  }
}
